export enum VENDOR_TYPE {
  INDIVIDUAL = "1",
  COMPANY = "2",
}

export enum MODIFIED_VENDOR_TYPE {
  INDIVIDUAL = "Individual",
  COMPANY = "Company",
}
